import { render, staticRenderFns } from "./request-info.vue?vue&type=template&id=cdf150ac&scoped=true&"
import script from "./request-info.vue?vue&type=script&lang=js&"
export * from "./request-info.vue?vue&type=script&lang=js&"
import style0 from "./request-info.vue?vue&type=style&index=0&id=cdf150ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf150ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
